import { TrophyIcon } from '@heroicons/react/24/solid'

/**
 * Compact score display chip for program/session cards.
 *
 * Color coding:
 * - Red (0-40): Low performance
 * - Yellow (40-70): Moderate performance
 * - Green (70-100): Good performance
 */
export function ScoreChip({ score, showTrophy = false, size = 'md' }) {
  if (score === null || score === undefined) {
    return null
  }

  const numScore = parseFloat(score)

  // Determine color based on score
  const getColorClasses = () => {
    if (numScore >= 70) {
      return 'bg-green-100 text-green-800 border-green-200'
    } else if (numScore >= 40) {
      return 'bg-yellow-100 text-yellow-800 border-yellow-200'
    } else {
      return 'bg-red-100 text-red-800 border-red-200'
    }
  }

  // Size classes
  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-0.5',
    lg: 'text-base px-3 py-1'
  }

  return (
    <span
      className={`
        inline-flex items-center gap-1 rounded-full border font-medium
        ${getColorClasses()}
        ${sizeClasses[size] || sizeClasses.md}
      `}
    >
      {showTrophy && <TrophyIcon className="h-3 w-3" />}
      <span>{numScore.toFixed(0)}</span>
      <span className="text-xs opacity-70">pts</span>
    </span>
  )
}

/**
 * Score change indicator showing improvement or decline.
 */
export function ScoreChange({ changePercent, size = 'sm' }) {
  if (changePercent === null || changePercent === undefined) {
    return null
  }

  const numChange = parseFloat(changePercent)
  const isPositive = numChange > 0
  const isNeutral = Math.abs(numChange) < 1

  const getColorClasses = () => {
    if (isNeutral) return 'text-gray-500'
    return isPositive ? 'text-green-600' : 'text-red-600'
  }

  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  }

  return (
    <span className={`${getColorClasses()} ${sizeClasses[size]} font-medium`}>
      {isPositive ? '+' : ''}{numChange.toFixed(1)}%
    </span>
  )
}

export default ScoreChip
